import React from 'react';
import { toast } from 'react-toastify';

export const InternetOfflineMessage = () => {
    const offlineToastId = React.useRef<undefined | string | number>(undefined);

    const handleOffline = () => {
        if (offlineToastId.current !== undefined) return;
        offlineToastId.current = toast.error("Your device might have lost access to the internet. Please check your network settings.", { autoClose: false });
    }

    const handleOnline = () => {
        if (offlineToastId.current === undefined) return;
        toast.dismiss(offlineToastId.current);
        offlineToastId.current = undefined;
    }

    React.useEffect(() => {
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        return () => {
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
        }
    }, []);

    return null;
}